import React from 'react';

import PropTypes from 'prop-types';

import { StyledButton } from './styles';

export default function IconButton({
  startIcon,
  label,
  backgroundColor,
  color,
  iconSize,
  className,
  disabled,
  ...props
}) {
  return (
    <StyledButton
      startIcon={startIcon}
      variant="contained"
      disabled={disabled}
      $bg={backgroundColor}
      $color={color}
      className={className}
      {...props}
    >
      {label}
    </StyledButton>
  );
}

IconButton.propTypes = {
  startIcon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  iconSize: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  backgroundColor: 'black',
  color: 'white',
  iconSize: 20,
  className: '',
  disabled: false,
};
